import { render, staticRenderFns } from "./SearchType.vue?vue&type=template&id=2275bf12&scoped=true&"
import script from "./SearchType.vue?vue&type=script&lang=js&"
export * from "./SearchType.vue?vue&type=script&lang=js&"
import style0 from "./SearchType.vue?vue&type=style&index=0&id=2275bf12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275bf12",
  null
  
)

export default component.exports